import type { Assistant } from 'modules/Distances/types';

export const remapWith = (selected: Array<Assistant>, list: Array<Assistant>): Array<Assistant> => {
  return selected.map((assistant) => {
    const timingAssistant = list.find((el) => el.id === assistant.id);

    return timingAssistant || assistant;
  });
};
